import { createAsyncThunk } from '@reduxjs/toolkit';

import { getDictionaries } from '../../utils/api';

export const fetchDictionaries = createAsyncThunk(
  'dictionaries/fetchDictionaries',
  () => getDictionaries(),
);
